
export const downloadFile = async (fileUrl: string, name: string, withCredentials: boolean = false, forceDownload: boolean = false) => {
  if (forceDownload) {
    try {
      const response = await fetch(fileUrl, {
        credentials: withCredentials ? "include" : "same-origin"
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = name;
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error('Force download failed:', error);
      window.open(fileUrl, '_blank');
    }
    return;
  }

  const fileName = name.toLowerCase();
  const isOfficeFile = fileName.endsWith('.xlsx') || 
                      fileName.endsWith('.xls') || 
                      fileName.endsWith('.docx') || 
                      fileName.endsWith('.doc') || 
                      fileName.endsWith('.pptx') || 
                      fileName.endsWith('.ppt');
  
  if (isOfficeFile) {
    const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
    window.open(officeViewerUrl, '_blank');
    return;
  }

  try {
    const response = await fetch(fileUrl, {credentials: "include"})
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error occurred while downloading the file:', error);
  }
};
